import { Loader } from "../../dom-tools/Loader";
import { TimestampMessage } from "../../messages/TimestampMessage";
import { ElementType } from "../../dom-tools/ElementType"; 
import { ElementAttribute } from "../../dom-tools/ElementAttribute";
import { OnClick } from "../../dom-tools/EventListeners";
import { CSS } from "../../css/CSS"; 
import { CSSPosition } from "../../css/CSSPosition";
import { CSSDisplay } from "../../css/CSSDisplay";
import { CSSOverflow } from "../../css/CSSOverflow";
import { PixelValue, ViewportHeightValue, ViewportWidthValue } from "../../css/CSSUnitValue";
import { CSSWhiteSpace } from "../../css/CSSWhiteSpace";
import { CSSHSLColor } from "../../css/CSSColor";
import { CSSCursor } from "../../css/CSSCursor";
import { CSSTextAlign } from "../../css/CSSTextAlign";
import { ClassFlag } from "../../dom-tools/ClassFlag";
import { MessageReader } from "../../messages/MessageReader";
import { PHPLexer } from "../../text/lexer/PHPLexer";
import { LexerQuery } from "../../text/lexer/LexerQuery";
import { HighlightedHTML } from "../../text/lexer/HighlightedHTML";
import { CSSCreator } from "../../css-definitions/CSSCreator";
import { HTMLEditor } from "../../dom-tools/HTMLEditor";

export class LogData
{
  uid:any;
  name:string;
  pageToken:string;
  messages:TimestampMessage[];
  flushingTime:string;
  htmlData:string;
}

export class LogEntrySelector extends HTMLElement
{
  _dataName:string;
}

export class LogView
{
  static readonly type = new ElementType( "log-view" );
  static readonly path = new ElementAttribute( "path" );

  static readonly naviList = new ElementType( "navi-list" );
  static readonly naviEntry = new ElementType<LogEntrySelector>( "navi-entry" );

  static readonly entryView = new ElementType( "entry-view" );
  static readonly logEntry = new ElementType( "log-entry" );
  static readonly logTime = new ElementType( "log-time" );

  static data:LogData[];

  private static _cssCreated = false;

  static createCSS()
  {
    if ( this._cssCreated )
    {
      return;
    }

    console.log( "Creating CSS" );

    let naviListCSS = new CSS();
    
    naviListCSS.position  = CSSPosition.absolute;
    naviListCSS.display   = CSSDisplay.block;
    naviListCSS.overflow  = CSSOverflow.scroll;
    naviListCSS.height    = new ViewportHeightValue( 100 );
    naviListCSS.width     = new ViewportWidthValue( 15 );
    naviListCSS.textAlign = CSSTextAlign.center;
    naviListCSS.appendToDOM( LogView.naviList.selector );


    let naviEntryCSS = new CSS();
    
    naviEntryCSS.display  = CSSDisplay.block;
    naviEntryCSS.margin = [ new PixelValue( 10 ), new PixelValue( 0 ) ];
    naviEntryCSS.padding = [ new PixelValue( 10 ), new PixelValue( 0 ) ];
    naviEntryCSS.cursor = CSSCursor.pointer;
    naviEntryCSS.appendToDOM( LogView.naviEntry.selector );

    let naviEntryHoverCSS = new CSS();
    naviEntryHoverCSS.backgroundColor = new CSSHSLColor( 0, 0, 15 );

    naviEntryHoverCSS.appendToDOM( LogView.naviEntry.selector + ":hover" );


    let naviEntrySelectedCSS = new CSS();
    naviEntrySelectedCSS.backgroundColor = new CSSHSLColor( 0, 0, 20 );

    let naviEntryWarnCSS = new CSS();    
    naviEntryWarnCSS.color = new CSSHSLColor( 60, 90, 60 );
    naviEntryWarnCSS.appendToDOM( LogView.naviEntry.selector +".warn" );

    let naviEntryErrorCSS = new CSS();    
    naviEntryErrorCSS.color = new CSSHSLColor( 0, 90, 60 );
    naviEntryErrorCSS.appendToDOM( LogView.naviEntry.selector +".error" );


    naviEntrySelectedCSS.appendToDOM( 
      LogView.naviEntry.selector + LogView.selected.selector + "," +
      LogView.naviEntry.selector + ":hover" + LogView.selected.selector
    );

    let entryViewCSS = new CSS();
    
    entryViewCSS.position   = CSSPosition.absolute;
    entryViewCSS.display    = CSSDisplay.block;
    entryViewCSS.overflowY   = CSSOverflow.scroll;
    entryViewCSS.overflowX   = CSSOverflow.hidden;
    entryViewCSS.height     = new ViewportHeightValue( 100 );
    entryViewCSS.width      = new ViewportWidthValue( 82 );
    entryViewCSS.left       = new ViewportWidthValue( 16 );
    entryViewCSS.whiteSpace = CSSWhiteSpace.pre_wrap;
    

    entryViewCSS.appendToDOM( LogView.entryView.selector );


    let logTimeCSS = new CSS();
    
    logTimeCSS.display    = CSSDisplay.block;
    logTimeCSS.margin = [ new PixelValue( 0 ), new PixelValue( 10 ) ];
    logTimeCSS.appendToDOM( LogView.logTime.selector );

    let logTimeWarnCSS = new CSS();    
    logTimeWarnCSS.color = new CSSHSLColor( 60, 100, 50 );
    logTimeWarnCSS.appendToDOM( LogView.logTime.selector + ".warn" );

    let logTimeErrorCSS = new CSS();    
    logTimeErrorCSS.color = new CSSHSLColor( 0, 100, 50 );
    logTimeErrorCSS.appendToDOM( LogView.logTime.selector + ".error" );

    let logEntryCSS = new CSS();
    
    logEntryCSS.display    = CSSDisplay.block;
    logEntryCSS.margin = [ new PixelValue( 0 ), new PixelValue( 10 ) ];
    logEntryCSS.marginBottom = new PixelValue( 40 );
    logEntryCSS.padding = new PixelValue( 10 );
    logEntryCSS.backgroundColor = new CSSHSLColor( 0, 0, 30 );

    logEntryCSS.appendToDOM( LogView.logEntry.selector );

    let logEntryWarnCSS = new CSS();    
    logEntryWarnCSS.backgroundColor = new CSSHSLColor( 60, 20, 30 );
    logEntryWarnCSS.appendToDOM( LogView.logEntry.selector +".warn" );

    let logEntryErrorCSS = new CSS();    
    logEntryErrorCSS.backgroundColor = new CSSHSLColor( 0, 20, 30 );
    logEntryErrorCSS.appendToDOM( LogView.logEntry.selector +".error" );

    let logEntryCodeCSS = new CSS();
    logEntryCodeCSS.fontFamily = "Ubuntu Mono";
    logEntryCodeCSS.fontSize = new PixelValue( 24 );
    logEntryCodeCSS.appendToDOM( LogView.logEntry.selector +" code" );
    
    let logEntryPathInfoCSS = new CSS();
    logEntryPathInfoCSS.fontSize = new PixelValue( 16 );
    logEntryPathInfoCSS.opacity = 0.5;
    logEntryPathInfoCSS.appendToDOM( LogView.logEntry.selector +" path-info" );

    this._cssCreated = true;

  }

  static selectedEntry:string = null;

  static async applyOnDocument()
  {
    let logView = LogView.type.queryDoc();

    if ( ! logView )
    {
      return;
    }


    this.createCSS();

    this.update();

    /*
    let path = LogView.path.from( logView );
    LogView.data = await Loader.request<LogData[],null>( path, null );

    //console.log( LogView.data );

    this.create();
    */

    

  } 

  static updateDurationMS = 5000;

  static async update()
  {
    let logView = LogView.type.queryDoc();
    let path = LogView.path.from( logView );
    
    LogView.data = await Loader.request<LogData[],null>( path, null );

    LogView.create();

    setTimeout( ()=>{ LogView.update() }, LogView.updateDurationMS );
  }

  static readonly selected = new ClassFlag( "selected" );

  static phpLexerStyledPushed = false;

  static setEntry( data:LogData )
  {
    if ( data.htmlData != null )
    {
      this.setHTMLEntry( data );
    }   
    else
    {
      this.setLogEntry( data );
    }
  }

  static setHTMLEntry( data:LogData )
  {
    let content = LogView.entryView.queryDoc();
    LogView.selectedEntry = data.name;

    content.innerHTML = "...loading...";

    LogView.highlightEntry( data );

    try
    {
      let iframe = ElementType.iframe.create();
      iframe.srcdoc = data.htmlData;
      
      iframe.style.width = "100%";
      iframe.style.height = "100%";
      iframe.style.border = "none";
      iframe.style.backgroundColor = "white";

      content.innerHTML = "";
      content.appendChild( iframe );
    }
    catch( e )
    {
      content.innerHTML = "Message couldn't be loaded";
    } 

    
    
  }

  static highlightEntry( data:LogData )
  {
    LogView.naviEntry.forAllInDoc(
      ( ne ) =>
      { 
        if ( ne._dataName === data.name )
        {
          LogView.selected.set( ne );
        }
        else
        {
          LogView.selected.removeFrom( ne );
        }
      }
    )
  }

  static setLogEntry( data:LogData )
  {
    let content = LogView.entryView.queryDoc();
    LogView.selectedEntry = data.name;

    content.innerHTML = "";

    let phpStackTraceRegex = /(#\d\s)\s*((?:(?:\w\:)?(?:\/|\\))?(?:\w|-|\.)+(?:(?:\/|\\)(?:\w|-|\.)+)+(?:\/|\\))((?:(?:\w|-)+).php)(\(\d+?\))\:\s*([^#]+)/g;

    let lexer = new PHPLexer();
    
    if ( ! this.phpLexerStyledPushed )
    {
      let styles = 
      `
      .php code-token-phpword:first-of-type
      {
        color:hsl(140,58%,74%)
      }

      .php code-token-phpword:nth-of-type(2)
      {
        color: hsl(90,78%,67%);
      }

      `
      styles = HighlightedHTML.createLexerStyles( lexer, ".php ", styles );
      CSSCreator.appendCSS( styles );
      this.phpLexerStyledPushed = true;
    }

    for ( let m of data.messages )
    {
      let type = new ClassFlag( m.type );
      let logTime = LogView.logTime.create( m.timestamp );
      content.appendChild( logTime );
      type.set( logTime );

      let messageContent = m.content;
      messageContent = messageContent.replace( phpStackTraceRegex, "$1 {{{$5}}} (((_==$3==_ $4 $2)))\n");

      let logEntry = LogView.logEntry.create( messageContent );
      new ClassFlag( "php" ).set( logEntry );

      let inner = logEntry.innerHTML;
      
      inner = inner.replace( /\{\{\{/g, "<code>");
      inner = inner.replace( /\}\}\}/g, "</code>");
      inner = inner.replace( /\(\(\(/g, "<path-info>");
      inner = inner.replace( /\)\)\)/g, "</path-info>");
      inner = inner.replace( /\(\(\(/g, "<path-info>");
      inner = inner.replace( /\)\)\)/g, "</path-info>");
      inner = inner.replace( /\_\=\=/g, "<b>");
      inner = inner.replace( /\=\=\_/g, "</b>");

      logEntry.innerHTML = inner;

      let codes = ElementType.code.queryAll( logEntry );
      codes.forEach(
        ( c )=>
        {
          let query = new LexerQuery();
          query.source = c.textContent;
          query.tokens = lexer.lexToList( c.textContent );
          c.innerHTML = HighlightedHTML.tokenize( query );          

        }
      )

      type.set( logEntry );

      content.appendChild( logEntry );
    }

    
    LogView.highlightEntry( data );    
  }

  static create()
  {
    let logView = LogView.type.queryDoc();
    let navi = LogView.naviList.query( logView ) || LogView.naviList.create();
    let entryView = LogView.entryView.query( logView ) ||LogView.entryView.create();

    if ( navi.parentElement === null )
    { logView.appendChild( navi ); }
    if ( entryView.parentElement === null )
    { logView.appendChild( entryView ); }


    LogView.data.sort(
      ( a, b )=>
      {
        let an = a.name;
        let bn = b.name;

        let sorted = [ an, bn ].sort();
        
        return an === sorted[ 0 ] ? 1 : -1;
        
      }
    )
    
    navi.innerHTML = "";

    for ( let i =0; i < LogView.data.length; i++ )
    {
      let data = LogView.data[ i ];
      let entry = LogView.naviEntry.create( data.name );
      entry._dataName = data.name;

      let mReader = new MessageReader( data.messages );
      let messageType = mReader.hasErrors ? "error" : mReader.hasWarnings ? "warn" : null;
      
      if ( messageType )
      {
        new ClassFlag( messageType ).set( entry ); 
      }

      if ( data.name === this.selectedEntry )
      {
        this.selected.set( entry );
      }

      OnClick.add( entry, ()=> { this.setEntry( data ); } );

      navi.appendChild( entry );
    }

    if ( LogView.selectedEntry === null )
    { 
      LogView.setEntry( LogView.data[ 0 ] );
    }

    
  }
}